import React from "react";

export default () => <svg fill="none" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M23.625 12C23.625 5.578 18.422.375 12 .375S.375 5.578.375 12c0 5.802
    4.251 10.612 9.809 11.484V15.36H7.23V12h2.954V9.439c0-2.914 1.734-4.523
    4.39-4.523 1.273 0 2.603.227 2.603.227v2.86H15.71c-1.444 0-1.895.896-1.895
    1.815V12h3.225l-.516 3.36h-2.709v8.124c5.558-.872 9.809-5.682 9.809-11.484z" />
</svg>
